import Http from '@/api/http.js'

export default {
  index(filter){
    return Http.get('/trucks', {
      params: {
        ...filter,
      }
    });
  },
  create(truck){
    return Http.post('/trucks', {
      truck
    });
    
  },
  update(truck) {
    return Http.put(`/trucks/${truck.id}`, {
      truck
    })
  },
  updateWithFormData(truck){
    return Http.put(`/trucks/${truck.get('truck[id]')}`, truck);
  },
  checkPlates(plates){
    return Http.get(`/trucks/check_plates`, {
      params: {
        plates,
      }
    });
  },
  show(id){
    return Http.get(`/trucks/${id}`);
  },
}